import { Section } from "@mittwald/flow-remote-react-components";
import { LayoutCard } from "@mittwald/flow-remote-react-components";
import { CustomLoadingSpinner } from "@wiesinghilker/extension-lib-frontend";
import { Tabs, Tab, TabTitle } from "@mittwald/flow-remote-react-components";
import { UserList } from "../components/User/UserList.tsx";
import { DirectoryProtectionList } from "../components/DirectoryProtection/DirectoryProtectionList.tsx";
import { Suspense } from "react";
import { useConfig } from "@mittwald/ext-bridge/react";

export const Lists = () => {
  const { projectId, extensionInstanceId } = useConfig();

  if (typeof projectId !== "string" || !projectId) {
    throw new Error("projectId is not defined");
  }

  if (typeof extensionInstanceId !== "string" || !extensionInstanceId) {
    throw new Error("extensionInstanceId is not defined");
  }

  return (
    <LayoutCard>
      <Tabs>
        <Tab id="folders">
          <TabTitle>Passwortschutz</TabTitle>
          <Section>
            <Suspense
              fallback={<CustomLoadingSpinner text={"Lade Passwortschutze"} />}
            >
              <DirectoryProtectionList projectId={projectId} />
            </Suspense>
          </Section>
        </Tab>
        <Tab id="users">
          <TabTitle>Benutzer</TabTitle>
          <Section>
            <Suspense
              fallback={<CustomLoadingSpinner text={"Lade Benutzer"} />}
            >
              <UserList projectId={projectId} />
            </Suspense>
          </Section>
        </Tab>
      </Tabs>
    </LayoutCard>
  );
};
